angular.module('cvsApp').service('scheduleNonPatientAppointmentService',['networkService', 'xdrService', 'configManager', 'commonModel', function (NS, XS,CM, CMOD) {
   	
	function scheduleNonPatientAppointmentService (){
		var self = this;
		this.scheduleNonPatientAppointment = function(data, callBackSuccess){
			//get url 
			var url = CM.getApiUrlWithApikeyAndCaptcha('SCHEDULE_NPA',data.captchaToken);
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{},
							data:getRequestBody(data),
							onSuccess:callBackSuccess
						}
			
				cvsUtility.commonServiceCode(url,"schedulenonpatientappointment",self,request,callBackSuccess,NS);	
			}
						
		}

		var getRequestBody = function(data){
			var requestJson =	{
				scheduleNonPatientRequest: {
					patientData:{
						firstName: data.firstName,
						lastName: data.lastName,
						phoneNumber: data.phone.replace(/-/g,'')
					},
					widgetSource: cvsUtility.queryMap.widgetSource || '',
					callMeAnyTimeFlag: data.callTime,
					choseADayDetails: data.day,
					choseTime: data.time
				}
			}

			return cvsUtility.JSONToXml(requestJson);
		}

		var resp;
		this.setData = function(data){
			resp = data;			
		}	

		this.getData = function(){				
			return resp;
		}
		
		this.setResponse = function(data){
			CMOD.setResponse(data);			
		}	

		this.getResponse = function(){				
			return CMOD.getCommonResponse();		
		}
	}
	
	return new scheduleNonPatientAppointmentService();	
}]);
